import React from 'react'
import intl from 'react-intl-universal'
import { StaticImage } from 'gatsby-plugin-image'
import { Navigation } from '@raysync/common/services'
import { YouTubeEmbed } from '@raysync/common/components'
import ArrowRight from '@raysync/common/components/svg/smb/arrow-3'
import { SmbButton } from '../home/banner/atoms'
import {
  EnterpriseBannerContainer,
  BannerIconBox,
  BannerIconItem,
  BannerLeft,
  BannerDesc,
  BannerWrap,
  BannerTitle,
  VideoWrapper,
} from './atoms'
import { ReactComponent as Icon1 } from './images/icon1.svg'
import { ReactComponent as Icon2 } from './images/icon2.svg'
import { ReactComponent as Icon3 } from './images/icon3.svg'

const iconList = [
  {
    svg: <Icon1 />,
    titleKey: 'enterprise.banner.tag.title1',
    descKey: 'enterprise.banner.tag.desc1',
  },
  {
    svg: <Icon2 />,
    titleKey: 'enterprise.banner.tag.title2',
    descKey: 'enterprise.banner.tag.desc2',
  },
  {
    svg: <Icon3 />,
    titleKey: 'enterprise.banner.tag.title3',
    descKey: 'enterprise.banner.tag.desc3',
  },
]
const EnterpriseBanner = () => {
  return (
    <EnterpriseBannerContainer>
      <BannerWrap>
        <BannerLeft>
          <BannerTitle>{intl.getHTML(`enterprise.banner.title`)}</BannerTitle>
          <BannerDesc>{intl.getHTML(`enterprise.banner.sub-title`)}</BannerDesc>
          <BannerIconBox>
            {iconList.map(icon => (
              <BannerIconItem>
                {icon.svg}
                <div>
                  <span>{intl.get(icon.titleKey)}</span>
                  <p>{intl.get(icon.descKey)}</p>
                </div>
              </BannerIconItem>
            ))}
          </BannerIconBox>
          <SmbButton
            id='raysync-enterprise'
            onClick={() => {
              Navigation.toApply({ type: 'apply', pageType: 'enterprise' })
            }}
          >
            {intl.get(`enterprise.banner.button`)}
            <ArrowRight />
          </SmbButton>
        </BannerLeft>
        <VideoWrapper>
          <YouTubeEmbed videoId='k1H_vGb-WCs' />
        </VideoWrapper>
      </BannerWrap>
      <StaticImage src='./images/banner.png' alt='Raysync enterprise banner' layout='fullWidth' className='billboard' />
    </EnterpriseBannerContainer>
  )
}
export default EnterpriseBanner
